import React from 'react';
var LayoutContext = React.createContext({});
export default LayoutContext;
